export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type AuthCodeCheckReponse = {
  __typename?: 'AuthCodeCheckReponse';
  status: Maybe<Scalars['Boolean']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export type BeginTwoFactorAuthenticatorSetupResponse = {
  __typename?: 'BeginTwoFactorAuthenticatorSetupResponse';
  errorCode: Maybe<TwoFactorAuthenticatorErrorCode>;
  manualKey: Maybe<Scalars['String']['output']>;
  otpauthUri: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type ConfirmTwoFactorAuthenticatorSetupResponse = {
  __typename?: 'ConfirmTwoFactorAuthenticatorSetupResponse';
  errorCode: Maybe<TwoFactorAuthenticatorErrorCode>;
  recoveryCodes: Array<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type CoverSetup = {
  __typename?: 'CoverSetup';
  coverSetupId: Maybe<Scalars['ID']['output']>;
  file: Maybe<Scalars['String']['output']>;
  size: Maybe<CoverSize>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type CoverSize = {
  __typename?: 'CoverSize';
  h: Maybe<Scalars['Int']['output']>;
  w: Maybe<Scalars['Int']['output']>;
};

export type CoverSizeInput = {
  h: Scalars['Int']['input'];
  w: Scalars['Int']['input'];
};

export type CoverUpdateDetails = {
  file: Scalars['String']['input'];
  size: CoverSizeInput;
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CustomLabel = {
  __typename?: 'CustomLabel';
  language: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type CustomLabelInput = {
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type DisableTwoFactorAuthenticatorResponse = {
  __typename?: 'DisableTwoFactorAuthenticatorResponse';
  errorCode: Maybe<TwoFactorAuthenticatorErrorCode>;
  status: Scalars['Boolean']['output'];
};

export type ImageForDisplay = {
  __typename?: 'ImageForDisplay';
  height: Maybe<Scalars['Int']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  photoGroupHasPhotoId: Scalars['String']['output'];
  photoGroupId: Maybe<Scalars['String']['output']>;
  photoId: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type KeywordsList = {
  __typename?: 'KeywordsList';
  keywordsListId: Maybe<Scalars['ID']['output']>;
  list: Maybe<Array<Maybe<PhotoKeywords>>>;
};

export type LoginCheckResponse = {
  __typename?: 'LoginCheckResponse';
  availableAccounts: Maybe<Array<Maybe<UserType>>>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type LoginStatus = {
  __typename?: 'LoginStatus';
  loginValid: Maybe<Scalars['Boolean']['output']>;
  token: Maybe<Scalars['String']['output']>;
  twoFactorRequired: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  beginTwoFactorAuthenticatorSetup: BeginTwoFactorAuthenticatorSetupResponse;
  confirmTwoFactorAuthenticatorSetup: ConfirmTwoFactorAuthenticatorSetupResponse;
  disableTwoFactorAuthenticator: DisableTwoFactorAuthenticatorResponse;
  finalizePhotographerRegistration: Maybe<RegisterPhotographerFinalizeResponse>;
  login: Maybe<LoginStatus>;
  logoutCurrentUser: Maybe<MutationStatus>;
  logoutDevice: Maybe<MutationStatus>;
  resetPassword: Maybe<PasswordCheckResponse>;
  sendPasswordResetEmail: Maybe<MutationStatus>;
  startPhotographerRegistration: Maybe<RegisterPhotographerInitResponse>;
};

export type MutationBeginTwoFactorAuthenticatorSetupArgs = {
  password: Scalars['String']['input'];
};

export type MutationConfirmTwoFactorAuthenticatorSetupArgs = {
  code: Scalars['String']['input'];
};

export type MutationDisableTwoFactorAuthenticatorArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationFinalizePhotographerRegistrationArgs = {
  code: Scalars['String']['input'];
  deviceId: Scalars['ID']['input'];
  deviceName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type MutationLoginArgs = {
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
  type?: InputMaybe<UserType>;
};

export type MutationLogoutDeviceArgs = {
  deviceId: Scalars['ID']['input'];
};

export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  deviceId: Scalars['ID']['input'];
  deviceName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};

export type MutationStartPhotographerRegistrationArgs = {
  input: RegisterPhotographerInput;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type MutationStatus = {
  __typename?: 'MutationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type NumberRange = {
  __typename?: 'NumberRange';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type PasswordCheckResponse = {
  __typename?: 'PasswordCheckResponse';
  firstName: Maybe<Scalars['String']['output']>;
  has2fa: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  token: Maybe<Scalars['String']['output']>;
  twoFactorChallengeId: Maybe<Scalars['ID']['output']>;
  twoFactorMethod: Maybe<TwoFactorMethod>;
};

export type PhotoKeywords = {
  __typename?: 'PhotoKeywords';
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  photoId: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  autoLogin: Maybe<PasswordCheckResponse>;
  checkAuthCode: Maybe<AuthCodeCheckReponse>;
  checkPassword: Maybe<PasswordCheckResponse>;
  checkPasswordResetCode: Maybe<MutationStatus>;
  loginExists: Maybe<LoginCheckResponse>;
  twoFactorAuthenticatorStatus: TwoFactorAuthenticatorStatus;
  x: Maybe<Scalars['String']['output']>;
};

export type QueryAutoLoginArgs = {
  token?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCheckAuthCodeArgs = {
  code: Scalars['String']['input'];
  deviceId: Scalars['ID']['input'];
  trustThisDevice: Scalars['Boolean']['input'];
  twoFactorChallengeId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCheckPasswordArgs = {
  deviceId: Scalars['ID']['input'];
  deviceName: Scalars['String']['input'];
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type QueryCheckPasswordResetCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type QueryLoginExistsArgs = {
  login: Scalars['String']['input'];
};

export type QuickLink = {
  __typename?: 'QuickLink';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  link: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quickLinkId: Maybe<Scalars['ID']['output']>;
};

export type RegisterPhotographerFinalizeResponse = {
  __typename?: 'RegisterPhotographerFinalizeResponse';
  firstName: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  token: Maybe<Scalars['String']['output']>;
};

export enum RegisterPhotographerInitErrorCode {
  EmailAlreadyTaken = 'EMAIL_ALREADY_TAKEN',
  PhoneAlreadyTaken = 'PHONE_ALREADY_TAKEN',
}

export type RegisterPhotographerInitResponse = {
  __typename?: 'RegisterPhotographerInitResponse';
  errorCode: Maybe<RegisterPhotographerInitErrorCode>;
  smsSent: Scalars['Boolean']['output'];
  status: Scalars['Boolean']['output'];
};

export type RegisterPhotographerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SoldFilesUniversalWatermarkConfig = {
  __typename?: 'SoldFilesUniversalWatermarkConfig';
  horizontal: Maybe<SoldFilesWatermarkConfig>;
  soldFilesUniversalWatermarkConfigId: Maybe<Scalars['ID']['output']>;
  vertical: Maybe<SoldFilesWatermarkConfig>;
};

export type SoldFilesWatermarkConfig = {
  __typename?: 'SoldFilesWatermarkConfig';
  alpha: Maybe<Scalars['Float']['output']>;
  config: Maybe<SoldFilesWatermarkConfigPosition>;
  file: Maybe<Scalars['String']['output']>;
  soldFilesWatermarkConfigId: Maybe<Scalars['ID']['output']>;
};

export type SoldFilesWatermarkConfigPosition = {
  __typename?: 'SoldFilesWatermarkConfigPosition';
  left: Maybe<Scalars['Float']['output']>;
  soldFilesWatermarkConfigPositionId: Maybe<Scalars['ID']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export enum TwoFactorAuthenticatorErrorCode {
  AlreadyEnabled = 'ALREADY_ENABLED',
  InvalidCode = 'INVALID_CODE',
  InvalidPassword = 'INVALID_PASSWORD',
  NotEnabled = 'NOT_ENABLED',
  RateLimited = 'RATE_LIMITED',
  SetupNotFound = 'SETUP_NOT_FOUND',
}

export type TwoFactorAuthenticatorStatus = {
  __typename?: 'TwoFactorAuthenticatorStatus';
  enabled: Scalars['Boolean']['output'];
  enabledAt: Maybe<Scalars['Int']['output']>;
  recoveryCodesRemaining: Scalars['Int']['output'];
};

export enum TwoFactorMethod {
  Authenticator = 'AUTHENTICATOR',
  Sms = 'SMS',
}

export enum UserType {
  Admin = 'Admin',
  Anonymous = 'Anonymous',
  CampaignManager = 'CampaignManager',
  Client = 'Client',
  CompetitionMember = 'CompetitionMember',
  Lab = 'Lab',
  LabEmployee = 'LabEmployee',
  LabManager = 'LabManager',
  LabOutsource = 'LabOutsource',
  LookbookMaestro = 'LookbookMaestro',
  MobileNativeClient = 'MobileNativeClient',
  OrdersManager = 'OrdersManager',
  PhotoFaceMatch = 'PhotoFaceMatch',
  Photographer = 'Photographer',
  RetouchManager = 'RetouchManager',
  Retoucher = 'Retoucher',
  Support = 'Support',
  WeddingCouple = 'WeddingCouple',
}

export enum ZalamoObject {
  BookingPortfolio = 'BookingPortfolio',
  CompetitionEntry = 'CompetitionEntry',
  Conversation = 'Conversation',
  DesignerAsset = 'DesignerAsset',
  DigitalOrder = 'DigitalOrder',
  LegacyPrivateSessionFileOrder = 'LegacyPrivateSessionFileOrder',
  LookBookOrder = 'LookBookOrder',
  OldZalamoClient = 'OldZalamoClient',
  Order = 'Order',
  Organization = 'Organization',
  OrganizationClient = 'OrganizationClient',
  OrganizationPromoPrintFlyers = 'OrganizationPromoPrintFlyers',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  Product = 'Product',
  ProductInOrder = 'ProductInOrder',
  PublicSession = 'PublicSession',
  PublicSessionChildren = 'PublicSessionChildren',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionOrganization = 'PublicSessionOrganization',
  PublicSessionOrganizationGroup = 'PublicSessionOrganizationGroup',
  SupportThread = 'SupportThread',
  ZalamoPrintOrder = 'ZalamoPrintOrder',
}
